{
  "AgentDetails_GUID": "Identificador (GUID):",
  "AgentNumber": "Número de agente:",
  "AgentDetails_Partition": "Partição:",
  "AgentDetails_Description": "Descrição:",
  "AgentDetails_UpdateExistingItems": "Atualizar itens duplicados:",
  "AgentDetails_GUIDPlaceholder": "[Auto Atribuído]",
  "AgentDetails_Validation_GUID": "O comprimento máximo de um GUID é de 100 caracteres",
  "AgentDetails_Validation_AgentNumber": "Deve ser fornecido um número de agente",
  "AgentDetails_Validation_Partition": "Deve ser selecionada uma partição",
  "AgentDetails_NonePartition": "[Nenhum]",
  "NAME": "AgentDetails"
}